import { useCallback } from "react";
import api from "../config/api/axiosConfig";

export const useRecipeApi = () => {
  const createRecipe = async (formData: FormData) => {
    const response = await api.post("/Recipe", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response;
  };

  // ✅ Get all recipes
  const getRecipes = useCallback(async () => {
    const response = await api.get("/Recipe");
    return response;
  }, []);

  const getRecipeById = async (id: number) => {
    const response = await api.get(`/Recipe/${id}`);
    return response;
  };

  // For image updates (with FormData)
  const updateRecipeImage = async (recipeId: number, formData: FormData) => {
    const response = await api.patch("/Recipe?recipeId=" + recipeId, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response;
  };

  const updateRecipeData = async (recipeId: number, data: any) => {
    const response = await api.patch("/Recipe?recipeId=" + recipeId, data, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response;
  };

  return {
    createRecipe,
    getRecipes,
    getRecipeById,
    updateRecipeImage,
    updateRecipeData,
  };
};
